require('./insuranceRequestPostalCodeInput.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const classNames = require('classnames');
const Geosuggest = require('react-geosuggest').default;
const { get } = require('lodash');

// @ utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const { browserIsIE11orBelow } = require('utilities/browserUtils')

// @ commons
const { InputSafe } = require('commonsComponents/inputSafe');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

// @ constants
const { TARGET_COUNTRY } = require('../../insuranceConstants/insuranceRequestHome');

class InsuranceRequestPostalCodeInput extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            emptyResults: false,
            error: false,
            showGuide: true,
            visible: false
        };

        this.handleEmptyResults = this.handleEmptyResults.bind(this);
        this.handleUpdateSuggests = this.handleUpdateSuggests.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentWillMount() {
        document.addEventListener('click', this.handleClickOutside)
    }

    componentWillUnMount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.node && this.node.contains(event.target)) {
            return;
        }

        this.setState({ visible: false })
    }

    handleEmptyResults(userInput) {
        const emptyResults = userInput ? true : false;
        this.setState({ emptyResults });
    }

    handleUpdateSuggests(suggests) {
        if (suggests.length) {
            this.setState({
                error: false,
                emptyResults: false,
                showGuide: false
            })
        } else if (!this.state.error) {
            this.setState({ showGuide: true });
        }
    }

    handleSelect(location) {
        if (!location) {
            this._geoSuggest.clear();
            return false;
        }

        let error = false;
        const locationItem = {
            postalCode: '',
            country: '',
            formattedAddress: ''
        };
        const { address_components, formatted_address } = location.gmaps

        address_components.map(addressItem => {
            if (addressItem.hasOwnProperty("types") && addressItem["types"].includes("postal_code")) {
                locationItem.postalCode = addressItem.short_name;
            }

            if (addressItem["types"].includes("country") && addressItem["short_name"] === TARGET_COUNTRY) {
                locationItem.formattedAddress = formatted_address;
                locationItem.country = addressItem.short_name;
            }
        });

        if (locationItem.postalCode.length) {
            this.props.onSelect(locationItem);
            this.handleVisibilityChange();
            this._input.focus();
        } else {
            error = true;
            this._geoSuggest.clear();
            this._geoSuggest.focus();
        }

        this.setState({
            error,
            emptyResults: false
        });
    }

    handleVisibilityChange() {
        this.setState({ visible: !this.state.visible }, () => {
            this._geoSuggest && this._geoSuggest.focus();
        });
    }

    getSuggestMessageStatus() {
        let msg;
        if (this.state.emptyResults) {
            msg = 'insuranceRequestHome-step2ConsultEmpty';
        } else if (this.state.error) {
            msg = 'insuranceRequestHome-step2ConsultNoCode';
        } else if (this.state.showGuide) {
            msg = 'insuranceRequestHome-step2ConsultFormat';
        }

        return msg ? <FormattedText value={msg} /> : '';
    }

    buildLabelTooltip() {
        return (
            <OKTooltip
                content="insuranceRequestHome-insuranceRequestHome_mesageTooltipPostalCode"
                offset={this.props.offset}
            />
        );
    }

    buildContent() {
        const messageClasses = classNames('insurance-request-postalcode__tooltip-message', {
            'insurance-request-postalcode__tooltip-message--guide': this.state.showGuide,
            'insurance-request-postalcode__tooltip-message--empty': this.state.emptyResults,
            'insurance-request-postalcode__tooltip-message--error': this.state.error,
        });

        const iExplorerValidation = browserIsIE11orBelow();
        const suggestsClassName = classNames('insurance-request-postalcode__geosuggest-list', {
            'insurance-request-postalcode__geosuggest-list--no-scroll': iExplorerValidation
        });
        const message = this.getSuggestMessageStatus();

        return (
            <div className="insurance-request-postalcode__tooltip-content">
                <label className="insurance-request-postalcode__tooltip-content-title">
                    {formatText('insuranceRequestHome-step2ConsultTitle')}
                </label>
                <i className="icon-buscar insurance-request-postalcode__geosuggest-icon"></i>
                <Geosuggest
                    className="insurance-request-postalcode__geosuggest"
                    suggestsClassName={suggestsClassName}
                    suggestItemClassName="insurance-request-postalcode__geosuggest-item"
                    inputClassName="insurance-request-postalcode__geosuggest-input"
                    onSuggestSelect={this.handleSelect}
                    onSuggestNoResults={this.handleEmptyResults}
                    onUpdateSuggests={this.handleUpdateSuggests}
                    placeholder={formatText('insuranceRequestHome-step2ConsultPlaceholder')}
                    ref={el => this._geoSuggest = el}
                    country={TARGET_COUNTRY}
                />
                <div className={messageClasses}>
                    {message}
                </div>
            </div>
        );
    }

    buildTarget() {
        return (
            <span className="insurance-request-postalcode__tooltip-target"
                onClick={this.handleVisibilityChange}>
                {formatText('insuranceRequestHome-step2Consult')}
            </span>
        );
    }

    render() {
        const {
            disablePostalCode,
            inputError,
            inputErrorMessage,
            isPostAppraisal,
            onBlurInput,
            onChangeInput,
            onFocusInput,
            value,
        } = this.props;

        const tooltipContent = this.state.visible ? (
            <div className="insurance-request-postalcode__tooltip">
                {this.buildContent()}
                <div className="insurance-request-postalcode__tooltip-arrow">
                    <div className="insurance-request-postalcode__tooltip-arrow-inner"></div>
                </div>
            </div>
        ) : null;

        return (
            <div className="insurance-request-postalcode" ref={node => this.node = node}>
                <label className="insurance-request-postalcode__label">
                    {formatText('insuranceRequestHome-postalCode')}
                    {!isPostAppraisal && !disablePostalCode && this.buildLabelTooltip()}
                </label>
                {!isPostAppraisal && !disablePostalCode && this.buildTarget()}
                <InputSafe
                    name="postalCodeInput"
                    ref={input => this._input = get(input, 'el')}
                    type="text"
                    maxLength={5}
                    value={value}
                    onChange={onChangeInput}
                    onBlur={onBlurInput}
                    onFocus={onFocusInput}
                    errorMessage={inputErrorMessage}
                    errorState={inputError}
                    disabled={isPostAppraisal || disablePostalCode}
                    placeholder={formatText('insuranceRequestHome-step2PostalCodePlaceholder')}
                />
                <div>
                    {tooltipContent}
                </div>
            </div>
        );
    }
}

InsuranceRequestPostalCodeInput.propTypes = {
    disablePostalCode: PropTypes.bool,
    inputError: PropTypes.bool,
    inputErrorMessage: PropTypes.string,
    isPostAppraisal: PropTypes.bool,
    offset: PropTypes.array,
    onBlurInput: PropTypes.func,
    onChangeInput: PropTypes.func,
    onFocusInput: PropTypes.func,
    onSelect: PropTypes.func,
    value: PropTypes.string,
};

InsuranceRequestPostalCodeInput.defaultProps = {
    disablePostalCode: false,
    isPostAppraisal: false,
}

module.exports = InsuranceRequestPostalCodeInput;
